<template>
  <div id="app">
    <div class="top box"></div>
    <!-- 第一部分 -->
    <div class="head box">
      <div class="content">
        <div class="head_title">蓝牙遥控器</div>
        <p>
          设备通过智能手机蓝牙控制器进行控制，具有通讯、实时视频、智能读取等多种操作功能。
        </p>
        <div class="control">
          <div class="Bluetooth">
            <img src="./image/qr.png" alt="二维码" />
          </div>
          <div class="downBtn">
            <!-- <img src="./image/btn1.png" alt="iPhone版下载" /> -->
            <a href="https://app-1304593553.cos.ap-guangzhou.myqcloud.com/app/ih_bluetooth.apk">
              <img src="./image/btn2.png" alt="Android版下载" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- APP 下载二维码部分 -->
    <div class="platform box">
      <div class="content">
        <div class="title">现场作业智能管控平台APP</div>
        <div class="explain">
          基于互联网B/S架构，与现场作业前段进行实时互动、数据存储、功能设置、场景显示和大数据分析。
        </div>
        <div class="control">
          <div class="Bluetooth">
            <img src="./image/qr1.png" alt="二维码" />
          </div>
          <div class="downBtn">
            <!-- <img src="./image/btn1.png" alt="iPhone版下载" /> -->
            <a href="https://app-1304593553.cos.ap-guangzhou.myqcloud.com/app/ih_app.apk">
              <img src="./image/btn2.png" alt="Android版下载" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 公众号二维码部分 -->
    <div class="footer box">
      <div class="QRcode">
        <div class="scan_code">
          <p>巨灵神智能终端公众号</p>
          <div class="Bluetooth">
            <img src="./image/official_account.png" alt="公众号" />
          </div>
          <div class="scan">请扫码关注</div>
        </div>
        <div class="scan_code">
          <p>巨灵神智能终端小程序</p>
          <div class="Bluetooth">
            <img src="./image/Applet.png" alt="小程序" />
          </div>
          <div class="scan">请扫码使用</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/components/download/index.stylus'
</style>
